import React, { useCallback, useRef, useEffect, useMemo } from 'react'
import { browserHistory } from 'react-router'
import Datagrid from '../../Component/Table/Produit'
import User from 'EurestoClass/User'

export default React.memo(props => {

  const metaKeyPressed = useRef(false);
  const name = useMemo(() => props && props.route && props.route.name, [props.route])
  const handleMetaKeyDown = e => {
    if (e.ctrlKey) {
      metaKeyPressed.current = true;
    }
  };

  const handleMetaKeyUp = e => {
    metaKeyPressed.current = false;
  };

  useEffect(() => {
    document.addEventListener('keydown', handleMetaKeyDown);
    document.addEventListener('keyup', handleMetaKeyUp);
    window.addEventListener('blur', handleMetaKeyUp);
    return () => {
      document.removeEventListener('keydown', handleMetaKeyDown);
      document.removeEventListener('keyup', handleMetaKeyUp);
      window.removeEventListener('blur', handleMetaKeyUp);
    };
  }, []);

  const update = useCallback((row) => {
    if (!metaKeyPressed.current) {
      browserHistory.push({
        pathname: '/gestion/' + row.id
      })
    } else {
      window.open('/gestion/' + row.id, '_blank');
    }
  }, [])

  return <Datagrid onClick={update} key={name}
    search={'gestion_produit_' + (name || '') + User.Entite.get().id} />
})










// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Page/Recherche/index.js